"use strict";

// Navtoggler
document.querySelector('.headerbar__navtoggler').addEventListener('click', () =>  {
    if (document.body.classList.contains('body--activenav')) {
    document.body.classList.remove('body--activenav');
    document.body.classList.remove('body--activesubnav');

    let clickedItems = document.querySelectorAll('.headerbar__mainnav a.clicked');

    for (let clickedItem of clickedItems) {
      clickedItem.classList.remove('clicked');
    }

    return;
  }

  document.body.classList.add('body--activenav');
});

// Offcanvas nav
let parents = document.querySelectorAll('.headerbar__mainnav > ul > li.parent > a');

for (let parent of parents) {
  parent.addEventListener('click', (e) =>  {
    if (document.body.clientWidth > 1279) {
      return;
    }

    if (e.target.classList.contains('clicked')) {
      return;
    }

    e.target.classList.add('clicked');
    e.preventDefault();
    document.body.classList.add('body--activesubnav');
  });
}

let subnavbuttons = document.querySelectorAll('.headerbar__mainnav .subnavhead > button');

for (let subnavbutton of subnavbuttons) {
  subnavbutton.addEventListener('click', (e) => {
    window.setTimeout(() => {
      e.target.parentElement.parentElement.previousElementSibling.classList.remove('clicked');
    }, 500)

  document.body.classList.remove('body--activesubnav');
 });
}
